"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  vgmApply: {
    title: 'VGM Declare',
    blNo: 'B/L No',
    containerNo: 'Container No',
    bkNo: 'Booking No',
    importFlag: 'Import Flag',
    wait: 'wait',
    accepted: 'accept',
    refuse: 'refuse',
    vesselCode: 'Vessel Code',
    voyageNo: 'Voyage No',
    vgmGrossWeight: 'VGM Weight',
    vgmScale: 'Weight Scale',
    vgmMethod: 'VGM Method',
    vgmDate: 'VGM Date',
    location: 'VGM Location',
    rejectReason: 'Reject Reason',
    operate: 'Operate',
    addSuccess: 'Add Success',
    addFail: 'Add Fail',
    delConfirm: 'Confirm Whether You Want to Delete?',
    delSuccess: 'Delete Success',
    delFail: 'Delete Fail',
    failures: 'failures',
    fileSize: 'File size cannot exceed 500KB!',
    checkSuccess: 'Calibration Success!'
  },
  button: {
    search: 'Search',
    reset: 'Reset',
    edit: 'Edit',
    view: 'View',
    delete: 'Delete',
    save: 'Save',
    saveCopy: 'Save&Copy',
    saveNew: 'Save&New',
    back: 'Back',
    new: 'New',
    copy: 'Copy',
    excel: 'Excel',
    print: 'Print',
    pdf: 'Pdf',
    importExcel: 'Import Excel',
    excelTemplate: 'Excel Template',
    sure: 'Sure',
    cancel: 'Cancel'
  },
  vgmApplyInfo: {
    title: 'VGM Details',
    vvl: 'VVL',
    blNo: 'B/L No',
    containerNo: 'Container No.',
    bkNo: 'Booking No.',
    importFlag: 'Import Status',
    wait: 'wait',
    accepted: 'accept',
    refuse: 'refuse',
    vesselCode: 'Vessel Code',
    voyageNo: 'Voyage No',
    voyageLeg: 'Voyage Leg',
    vgmGrossWeight: 'VGM Weight',
    vgmScale: 'VGM Scale',
    vgmMethod: 'VGM Method',
    vgmDate: 'VGM Date',
    location: 'VGM Location',
    rejectReason: 'Reject Reason',
    vesselName: 'Vessel Name',
    vesselName1: 'Vessel Name(CN)',
    containerType: 'Type',
    containerOther: 'Other',
    remark: 'Remark',
    shipperName: 'Shipper Name',
    shipperAddress: 'Shipper ADD',
    shipperVgmName: 'VGM Contacts',
    shipperVgmEmail: 'VGM E-mail',
    shipperVgmTelephone: 'VGM Tel',
    vgmCertificateId: 'Certificate ID',
    shipperVgmPerson: 'VGM PIC',
    shipperVgmPersonSig: 'PIC Signature',
    vgmDeclarationParty: 'Declaration Party',
    vgmEquipmentId: 'Equipment Id',
    shipperOther: 'Other',
    name: 'Name',
    contactName: 'Contact',
    contactTelephone: 'TEL',
    address: 'Address',
    contactEmail: 'E-mail',
    contactPerson: 'PIC',
    contactPersonSig: 'PIC Signature',
    contactOther: 'Other'
  },
  vgmInfo: {
    title: 'VGM Info Query',
    blNo: 'B/L No.',
    containerNo: 'Container No.',
    queryType: 'Query type',
    bookingNo: 'Booking No.',
    vvl: 'VVL',
    containerType: 'Type',
    vgmGrossWeight: 'VGM Weight',
    vgmScale: 'Weight Scale',
    vgmMethod: 'VGM Method',
    vgmDate: 'VGM Date',
    location: 'VGM Location',
    VVLNotNull: 'VVL is null！',
    weightNotNull: 'VGM Weight is null！',
    methodNotNull: 'VGM Method is null！',
    scaleNotNull: 'Weight Scale is null！',
    weightAbnormal: 'weight cannot less than 2000 or more than 50000！',
    bkblNoNotNull: 'B/L No/Booking No must be filled in one！',
    emailMessage: 'Please enter the correct email address！',
    containerMessage: 'Container No format is incorrect！'
  },
  validate: {
    userNameNotNull: 'User name is null',
    userNameISNull: 'User name is not empty',
    userNameExist: 'User name already exists',
    userNameIsWrong: 'User name is no less than five and no more than twenty-five',
    nameIsNull: 'Name is not null',
    passwordNotNull: 'Password is null',
    passwordIsShort: 'Password is not less than six',
    passwordIsSimple: 'Must contain uppercase and lowercase letters as well as special characters',
    passwordNotTrue: 'Incorrect password entered twice',
    emailNotNull: 'Email is null',
    authorizeCodeNotExist: 'Authorize Code is not exist,Please send an email to email: cs-shipping@sitc.com to obtain',
    authorizeCodeNotNull: 'Authorize Code is null,Please send an email to email: cs-shipping@sitc.com to obtain',
    emailNotTrue: 'E-mail format is incorrect',
    code: 'code is Null',
    pol: 'POL is Null',
    pod: 'POD is Null',
    vesselName: 'Vessel Name is null',
    blNo: 'B/L No is null',
    bkNo: 'Booking No is null',
    containerNo: 'Container No is null',
    date: 'Start Date is null',
    checkBlNo: 'blNo or containerNo is wrong !',
    inputNo: 'inputNo is null',
    refNo: 'refNo is null',
    bookingNo: 'Booking No is null'
  }
};